import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Stamp = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 21C28 19.346 26.654 18 25 18H22.875C21.29 18 20 16.71 20 15.125V8C20 5.794 18.206 4 16 4C13.794 4 12 5.794 12 8V15.125C12 16.71 10.71 18 9.125 18H7C5.346 18 4 19.346 4 21C4 22.331 4.872 23.462 6.074 23.853C6.48 26.205 8.534 28 11 28H21C23.466 28 25.519 26.205 25.926 23.853C27.129 23.462 28 22.331 28 21ZM21 26H11C9.696 26 8.584 25.164 8.171 24H23.828C23.415 25.164 22.303 26 20.999 26H21ZM25 22H7C6.449 22 6 21.551 6 21C6 20.449 6.449 20 7 20H9.125C11.813 20 14 17.813 14 15.125V8C14 6.897 14.897 6 16 6C17.103 6 18 6.897 18 8V15.125C18 17.813 20.187 20 22.875 20H25C25.551 20 26 20.449 26 21C26 21.551 25.551 22 25 22Z" />
	</svg>
);

export default Stamp;
